import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { LeadProvider } from "@/context/LeadContext";
import { LeadCaptureDialog } from "@/components/site/LeadCaptureDialog";
import Landing from "@/pages/Landing";
import PricingPage from "@/pages/PricingPage";
import PaymentSuccess from "@/pages/PaymentSuccess";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!window.location.hash) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <LeadProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="*" element={<Landing />} />
            </Routes>
            <LeadCaptureDialog />
            <Toaster position="top-center" richColors />
          </LeadProvider>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
